import { Vector2 } from './types';

class ScorePopup {
  position: Vector2;
  score: number;
  alive: boolean = true;
  timer: number = 0;
  maxTime: number = 1.5;
  initialY: number;
  alpha: number = 1;

  constructor(x: number, y: number, score: number) {
    this.position = { x, y };
    this.initialY = y;
    this.score = score;
  }

  update(deltaTime: number): void {
    this.timer += deltaTime;
    if (this.timer >= this.maxTime) {
      this.alive = false;
      return;
    }

    this.position.y = this.initialY - (this.timer * 30);
    this.alpha = Math.max(0, 1 - (this.timer / this.maxTime));
  }

  render(ctx: CanvasRenderingContext2D): void {
    ctx.save();
    ctx.globalAlpha = this.alpha;
    ctx.fillStyle = '#ffff00';
    ctx.font = 'bold 20px Arial';
    ctx.textAlign = 'center';
    ctx.strokeStyle = '#000000';
    ctx.lineWidth = 3;
    ctx.strokeText(`+${this.score}`, this.position.x, this.position.y);
    ctx.fillText(`+${this.score}`, this.position.x, this.position.y);
    ctx.restore();
  }
}

export class ScorePopupManager {
  private popups: ScorePopup[] = [];

  update(deltaTime: number): void {
    this.popups.forEach(popup => popup.update(deltaTime));
    this.popups = this.popups.filter(popup => popup.alive);
  }

  render(ctx: CanvasRenderingContext2D): void {
    this.popups.forEach(popup => popup.render(ctx));
  }

  addScorePopup(x: number, y: number, score: number): void {
    this.popups.push(new ScorePopup(x, y, score));
  }

  clear(): void {
    this.popups = [];
  }
}